module.exports = __webpack_public_path__ + "img/64.2d0388b9.jpg";